module.exports = __webpack_public_path__ + "img/m_line2.31707826.png";